import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_INTERVENTIONTYPES } from "../../../utils/constants";
import interventionTypeService from "../../../services/ticketService/interventionTypeService";
import { InterventionTypeInterface } from "../../../models/TicketModule/InterventionType";

const useInterventionTypeById = (id: string) =>
  useQuery<InterventionTypeInterface, Error>({
    queryKey: [`${CACHE_KEY_INTERVENTIONTYPES}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, interventionTypeId] = queryKey;
      return interventionTypeService.GetById(interventionTypeId as string);
    },
    enabled: !!id,
  });

export default useInterventionTypeById;
